module.exports = __webpack_public_path__ + "static/mysa-mattress-3-1b80d03c77143f96ff2b702514990792.png";